import { render, staticRenderFns } from "./FooterBottom.vue?vue&type=template&id=0616ed7c&scoped=true&"
import script from "./FooterBottom.vue?vue&type=script&lang=js&"
export * from "./FooterBottom.vue?vue&type=script&lang=js&"
import style0 from "./FooterBottom.vue?vue&type=style&index=0&id=0616ed7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616ed7c",
  null
  
)

export default component.exports